<template lang="pug" src="./custom-home-bowl-section.pug"></template>

<script>
import { trigger } from '@/shared/functionality/mixins'

export default {
  props: ['props'],
  data () {
    return {
      animate: -1
    }
  },
  mixins: [ trigger ],
  methods: {
    animation ({ going, direction }) {
      if (going === 'in' && direction === 'top') {
        setTimeout(e => { this.animate = 0 }, 100)
        setTimeout(e => { this.animate = 1 }, 1000)
        setTimeout(e => { this.animate = 2 }, 2000)
        setTimeout(e => { this.animate = 3 }, 3000)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-bowl-section/custom-home-bowl-section.vue